export function handleResult(result) {
    return result.data;
}